import React from 'react';
import LegalPage from './LegalPage';

export default function MentionsLegales() {
  return (
    <LegalPage
      title="Mentions légales"
      subtitle="Informations légales — TripNova SaaS"
      lastUpdate="31 mai 2026"
      testid="page-mentions-legales"
    >
      <h2>1. Éditeur du Service</h2>
      <p>
        Le service <strong>TripNova SaaS</strong>, plateforme CRM pour agences de voyages, est édité par :
      </p>
      <ul>
        <li><strong>Nom commercial</strong> : TripNova</li>
        <li><strong>Adresse</strong> : Alger, Algérie</li>
        <li><strong>Email</strong> : <a href="mailto:aatvgeste@gmail.com">aatvgeste@gmail.com</a></li>
        <li><strong>Directeur de la publication</strong> : Responsable TripNova</li>
      </ul>

      <h2>2. Hébergement</h2>
      <p>
        La plateforme est hébergée sur une infrastructure cloud sécurisée avec :
      </p>
      <ul>
        <li>Base de données <strong>MongoDB</strong> (chiffrée, sauvegarde quotidienne automatisée).</li>
        <li>Cache <strong>Redis Upstash</strong> (région eu-west-1, Irlande).</li>
        <li>Monitoring <strong>Sentry</strong> pour la détection d'erreurs.</li>
        <li>Email transactionnel via <strong>Resend</strong>.</li>
      </ul>

      <h2>3. Propriété intellectuelle</h2>
      <p>
        L'ensemble des éléments composant la plateforme TripNova (code source, design, logo, textes,
        documentation) est protégé par le droit de la propriété intellectuelle.
      </p>
      <p>
        Toute reproduction, représentation, modification, publication, transmission, dénaturation,
        totale ou partielle du Service ou de son contenu, par quelque procédé que ce soit, et sur
        quelque support que ce soit, est interdite sans autorisation écrite préalable de l'Éditeur.
      </p>

      <h2>4. Données collectées</h2>
      <p>
        Les modalités de collecte et de traitement des données personnelles sont décrites dans notre{' '}
        <a href="/rgpd">Politique de confidentialité (RGPD)</a>.
      </p>

      <h2>5. Conditions d'utilisation</h2>
      <p>
        L'utilisation du Service est régie par nos{' '}
        <a href="/cgu">Conditions Générales d'Utilisation</a> et nos{' '}
        <a href="/cgv">Conditions Générales de Vente</a>.
      </p>

      <h2>6. Crédits</h2>
      <ul>
        <li>Icônes : <a href="https://phosphoricons.com" target="_blank" rel="noreferrer">Phosphor Icons</a></li>
        <li>Framework : React + Tailwind CSS</li>
        <li>Backend : FastAPI (Python)</li>
      </ul>

      <h2>7. Contact</h2>
      <p>
        Pour toute question, réclamation ou demande d'information :
      </p>
      <ul>
        <li>Email : <a href="mailto:aatvgeste@gmail.com">aatvgeste@gmail.com</a></li>
      </ul>
    </LegalPage>
  );
}
